import(/* webpackMode: "eager" */ "/codebuild/output/src3389300352/src/src/app/(public)/adopt/[shelterKey]/page.tsx");
